import { categories } from "@/mocks/categories";
import SectionHeading from "./SectionHeading";

export default function CategoriesSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <section id="categories" className="w-full bg-background-50 px-4 md:px-8 py-14 md:py-20">
      <div className="w-full">
        <SectionHeading
          eyebrow="主题分类"
          title="先定方向，再逐个补课"
          desc="不同的人关注的点不一样。有人只想追剧集的番位与路透，有人只关心音乐现场和票务。挑一个方向，剩下的交给筛选。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {categories.map((cat, index) => (
            <article
              key={cat.id}
              className={`group rounded-lg border p-5 md:p-6 transition-colors cursor-pointer ${
                index === 0
                  ? "bg-primary-500/5 border-primary-300 hover:border-primary-500"
                  : "bg-background-100/60 border-background-200 hover:border-secondary-400"
              }`}
              onClick={() => scrollTo("events")}
            >
              <div className="flex items-start justify-between mb-4">
                <span
                  className={`w-12 h-12 flex items-center justify-center rounded-md text-2xl ${
                    index === 0
                      ? "bg-primary-500 text-background-50"
                      : "bg-secondary-100 text-secondary-700"
                  }`}
                >
                  <i className={cat.icon} />
                </span>
                <span className="text-xs text-foreground-500">{cat.count} 篇盘点</span>
              </div>
              <h3 className="font-heading font-bold text-foreground-950 text-lg md:text-xl mb-2">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{cat.desc}</p>
              <span
                className={`inline-flex items-center gap-1 text-sm font-medium ${
                  index === 0 ? "text-primary-600" : "text-secondary-700"
                }`}
              >
                查看该分类
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}